export default {
  List: {
    Title: "Quản lý tài khoản",
    Role: "Vai trò",
    Status: "Trạng thái",
    EmailSearch: "Tìm theo email",
    SearchTitle: "Nhập họ tên, email hoặc SĐT để tìm kiếm",
    Add: "Thêm",
    SearchText: "Nhập nội dung tìm kiếm",
  },
  Table: {
    UserCode: "Mã nhân viên",
    Name: "Họ và tên",
    PhoneNumber: "Số điện thoại",
    Email: "Email",
    Position: "Chức vụ",
    Role: "Vai trò",
    Status: "Trạng thái",
    ManagementTransaction: "Q.lý GD",
    ManagementControl: "Q.lý đối soát",
    Paymentlinks: "Payment links",
    ComplainRefund: "Khiếu nại và hoàn tiền",
    Setting: "Thiết lập",
    UpdateRequest: "Yêu cầu cập nhật hồ sơ",
    ProfileInfo: "Hồ sơ đăng kí",
    IsMerchantAdministrator: "Là tài khoản quản trị",
  },
  Detail: {
    AddTitle: "Thêm tài khoản",
    EditTitle: "Sửa tài khoản",
    UserNotActive: "Ngừng hoạt động",
    UserActive: "Đang hoạt động",
    DeleteTitle: "Xóa tài khoản",
    Email: "Email",
    EmailPlaceholder: "Nhập Email",
    Phone: "Số điện thoại",
    PhonePlaceholder: "Nhập số điện thoại",
    FullName: "Họ và tên",
    FullNamePlaceholder: "Nhập họ và tên",
    DuplicateTitle: "Nhân bản tài khoản",
  },
  Message: {
    DeleteUserMessage: "Bạn có chắc chắc muốn xóa tài khoản",
    WarningDecentralization: "Tài khoản cần được phân ít nhất 1 quyền",
    UserIsNotActive: "Tài khoản đang ở trạng thái ngừng hoạt động",
    IsExistEmail: "Tài khoản đã tồn tại trên hệ thống",
    FullNameNotValidate: "Họ và tên không hợp lệ",
    EditSuccess: "Lưu tài khoản thành công",
    SaveSuccess: "Thêm tài khoản thành công",
    DeleteSuccess: "Xóa tài khoản thành công",
    Error: "Có lỗi xảy ra. Vui lòng thử lại!",
  },
  Confirm: {
    Delete: "Bạn có muốn xóa tài khoản",
  },
};
